"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTokenExpired = void 0;
const getTokenPayload_1 = require("./getTokenPayload");
function isTokenExpired(token) {
    if (!token)
        return true;
    try {
        const { exp } = (0, getTokenPayload_1.getTokenPayload)(token);
        const currentDate = new Date();
        const currentEpoch = Math.floor(currentDate.getTime() / 1000);
        if (exp < currentEpoch) {
            return true;
        }
    }
    catch (e) {
        // can not read payload
        // eslint-disable-next-line no-console
        console.error(`Cannot read token payload`, e);
    }
    return false;
}
exports.isTokenExpired = isTokenExpired;
//# sourceMappingURL=isTokenExpired.js.map